import { gql } from 'glimmer-apollo';

export const ESPORTS_GAME_QUERY = gql`
  query GetEsportsGamePage($slug: String!) {
    eSportsGamePage(slug: $slug) {
      game {
        id
        name
        slug
      }
      articles {
        title
        shortDescription
        slug
        publishedDate
        eSportsGame {
          id
          name
          slug
        }
        author {
          name
          avatar {
            url
            description
          }
        }
        coverImage {
          url
          description
        }
      }
      popularArticles {
        title
        slug
        coverImage {
          url
        }
      }
      liveStreamers {
        id
        userName
        userDisplayName
        title
        viewerCount
        thumbnailUrl
        profileImageUrl
        gameName
      }
      stats {
        totalArticles
        totalStreamers
      }
    }
  }
`;
